import axios from 'axios';

// Create axios instance with base URL
const api = axios.create({
  baseURL: 'https://suitupapi.club',
  headers: {
    'Accept': 'applicant api; version=1',
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Preserve custom Accept header if it's set in the request config
    if (!config.headers['Accept']) {
      config.headers['Accept'] = 'applicant api; version=1';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      // Clear local storage if not on login/register pages
      const isAuthPage = window.location.pathname.includes('/login') || 
                         window.location.pathname.includes('/register') ||
                         window.location.pathname.includes('/reset-password');
      
      if (!isAuthPage) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        
        // Redirect to login page
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
